<template>
  <v-container>
    
    <v-row justify="center" align="center">
      <v-col cols="4" v-for="apps in tempdata" :key="apps.app_id">
        <v-card :loading="loading" class="mx-auto my-12" max-width="374">
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <v-img height="250" :src="apps.image_path"></v-img>

          <v-card-title>{{ apps.app_name }}</v-card-title>

          <v-card-text>
            <div>{{ apps.description }}</div>
          </v-card-text>

          <v-divider class="mx-4"></v-divider>

          <v-card-actions>
            <v-btn
              color="deep-purple lighten-2"
              text
              @click="clickonlink(apps.app_url,apps.app_id)"
            >
              Open
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from "../../../apis/apifactory";

Vue.use(VueAxios, axios);
export default {
  name: "ExtraAuth",
  data: () => ({
    userid: null,
    appItems: null,
    appItemsprefered: "",
    msg: "",
    tempdata: []
  }),
  computed: {
    
  },
  mounted() {
    this.getapitest();
   
  },
  methods: {
    
    getapitest() {
      alert('ddd');
      apifactory
        .testapi()
        .then((res) => {
           alert(res);
       })
        .catch(function (error) {
          console.warn(error);
        });
    }
  },
};
</script>

<style scoped>
.linkdiv {
  cursor: pointer;
}
</style>
